// extracted by mini-css-extract-plugin
export default {"main-section":"MainSection_main-section__1JXAh","main-title":"MainSection_main-title__Lzfuh","main-description":"MainSection_main-description__PsWSV"};